import React from "react"
import { FormattedMessage } from "react-intl"

export const getImportListingHeaders = () => {
    return [
        <>
            <FormattedMessage
                id="listing.product.import.list.headers.title_label"
                defaultMessage="Integration"
            />
        </>,
        <>
            <FormattedMessage
                id="listing.product.import.list.headers.status_label"
                defaultMessage="Status"
            />
        </>,
        <>
            <FormattedMessage
                id="listing.product.import.list.headers.nb_item_imported_label"
                defaultMessage="Item imported"
            />
        </>,
        <>
            <FormattedMessage
                id="listing.product.import.list.headers.duration_label"
                defaultMessage="Duration"
            />
        </>,
        <>
            <FormattedMessage
                id="listing.product.import.list.headers.created_at_label"
                defaultMessage="Created at"
            />
        </>,
    ]
}


// WEBPACK FOOTER //
// ./src/utils/external/utils.tsx